import { isFiniteDecimal } from '@eastcoal/common/utils/decimal'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { SplitMethod } from '@eastcoal/shared/enums/SplitMethod'

export const splitValuesValidator: SchemaItem['x-validator'] = {
  validator(_, __, ctx) {
    const { splitMethod, dealCount, quantity, splitValues, wholeSale } =
      ctx.form.values
    // 拆分拍不需要校验
    if (!wholeSale) {
      return null
    }

    if (splitMethod === SplitMethod.EQUALLY && quantity && dealCount) {
      if (!isFiniteDecimal(quantity, dealCount)) {
        return `拆分失败，数量（${quantity}）无法平分为 ${dealCount} 份`
      }
    }

    if (splitMethod === SplitMethod.PROPORTIONAL) {
      const totalPercents = splitValues.reduce(
        (total: number, value: number) => total + value,
        0
      )
      if (totalPercents !== 100) {
        return '拆分失败，拆分比例总和必须为 100%'
      }
    }

    if (splitMethod === SplitMethod.FIXED) {
      const totalFixed = splitValues.reduce(
        (total: number, value: number) => total + value,
        0
      )
      if (totalFixed !== quantity) {
        return `拆分失败，拆分数量总和必须为 ${quantity}`
      }
    }

    return null
  }
}
